import React, { useState } from 'react';
import { Card, Select, Table, Tag, Button, Avatar } from 'antd';

const { Option } = Select;

export default function DashboardLocationView() {
  const [selectedRole, setSelectedRole] = useState('telesale');
  const [activeTaskTab, setActiveTaskTab] = useState('overdue');

  // Khởi tạo danh sách công việc đầy đủ cho các tab
  const [tasks, setTasks] = useState([
    // Quá hạn (4)
    { id: 1, tab: 'overdue', title: 'Gọi lại Ms. Trần Thu Vân – hẹn 28/08, 16:00', desc: 'K-Lift Signature · Giá trị dự kiến 68 tr', tagText: '18g quá hạn', tagColor: 'red', completed: false },
    { id: 2, tab: 'overdue', title: 'Hoàn thiện hồ sơ tài sản cơ sở Quận 1', desc: 'Kho Thị CMS · Quản lý tài sản', tagText: '1 ngày quá hạn', tagColor: 'red', completed: false },
    { id: 3, tab: 'overdue', title: 'Xác thực thông tin khách hàng VIP tồn đọng', desc: 'CSKH · Cần xử lý gấp', tagText: '2 ngày quá hạn', tagColor: 'red', completed: false },
    { id: 4, tab: 'overdue', title: 'Kiểm tra chứng từ thanh toán hợp đồng tháng trước', desc: 'Kế toán · Duyệt gấp', tagText: '3 ngày quá hạn', tagColor: 'red', completed: false },

    // Hôm nay (5)
    { id: 5, tab: 'today', title: 'Gửi báo giá Newhair 2.500 nang cho Mr. Lê Quốc Bảo', desc: 'Đã hứa gửi 28/08 · 195 tr', tagText: 'Hôm nay', tagColor: 'orange', completed: false },
    { id: 6, tab: 'today', title: 'Xác nhận cọc Ms. Phạm Hồng Nhung – 10 tr', desc: 'Chờ chuyển khoản · 92 tr', tagText: 'Hôm nay', tagColor: 'orange', completed: false },
    { id: 7, tab: 'today', title: 'Cập nhật kết quả 4 lead nhóm K·Reshape lên CMS', desc: 'Thiếu trạng thái', tagText: 'Hôm nay', tagColor: 'default', completed: false },
    { id: 8, tab: 'today', title: 'Gọi điện chăm sóc khách hàng lịch hẹn buổi chiều', desc: 'Tư vấn Online · 10 lead', tagText: 'Hôm nay', tagColor: 'orange', completed: false },
    { id: 9, tab: 'today', title: 'Gửi báo cáo hiệu suất làm việc đầu ca', desc: 'Quản lý cơ sở', tagText: 'Hôm nay', tagColor: 'default', completed: false },

    // Cần xử lý (3)
    { id: 10, tab: 'handle', title: 'Kiểm tra lại hợp đồng ký quỹ của đối tác', desc: 'Pháp lý · Chờ xử lý gấp', tagText: 'Cần duyệt', tagColor: 'red', completed: false },
    { id: 11, tab: 'handle', title: 'Phối hợp xử lý khiếu nại giá dịch vụ của Ms. Vũ Lan Chi', desc: 'Hotline · Cần giải quyết', tagText: 'Ưu tiên', tagColor: 'red', completed: false },
    { id: 12, tab: 'handle', title: 'Phê duyệt lịch trực ca tuần tới cho nhân sự', desc: 'Nhân sự · Điều phối', tagText: 'Cần xử lý', tagColor: 'orange', completed: false },

    // Việc tồn (3)
    { id: 13, tab: 'remain', title: 'Rà soát danh sách khách hàng tồn đọng tuần trước', desc: 'CSKH · Tồn tuần', tagText: 'Tồn đọng', tagColor: 'default', completed: false },
    { id: 14, tab: 'remain', title: 'Cập nhật tài liệu quy trình tư vấn mới vào kho', desc: 'Marketing · Tồn kho', tagText: 'Việc tồn', tagColor: 'default', completed: false },
    { id: 15, tab: 'remain', title: 'Kiểm tra kho ấn phẩm truyền thông tại quầy', desc: 'Cơ sở Quận 1 · Tồn đọng', tagText: 'Việc tồn', tagColor: 'default', completed: false },

    // Sắp tới (4)
    { id: 16, tab: 'upcoming', title: 'Họp giao ban tuần đầu tháng 09/2026', desc: 'Phòng Quản lý · 09:00 sáng', tagText: 'Sắp tới', tagColor: 'cyan', completed: false },
    { id: 17, tab: 'upcoming', title: 'Tổng kết doanh số tháng 08/2026', desc: 'Kinh doanh · Đánh giá target', tagText: 'Sắp tới', tagColor: 'cyan', completed: false },
    { id: 18, tab: 'upcoming', title: 'Đào tạo nội bộ bộ nhận diện K-Protocol System bản 2.0', desc: 'Đào tạo · Online', tagText: 'Sắp tới', tagColor: 'cyan', completed: false },
    { id: 19, tab: 'upcoming', title: 'Triển khai chính sách cọc dịch vụ mới từ 01/09', desc: 'Hệ thống · Áp dụng chung', tagText: 'Sắp tới', tagColor: 'cyan', completed: false },
  ]);

  // Hàm xử lý check hoàn thành công việc
  const handleToggleTask = (id: number) => {
    setTasks(prevTasks =>
      prevTasks.map(task =>
        task.id === id ? { ...task, completed: !task.completed } : task
      )
    );
  };

  // Lọc danh sách công việc theo tab đang chọn
  const filteredTasks = tasks.filter(task => task.tab === activeTaskTab);

  const customerColumns = [
    {
      title: 'KHÁCH HÀNG',
      dataIndex: 'customer',
      key: 'customer',
      render: (text, record) => (
        <div className="flex items-center space-x-3">
          <Avatar className="bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-200 font-bold">{record.avatar}</Avatar>
          <div>
            <div className="font-semibold text-slate-800 dark:text-slate-100">{record.name}</div>
            <div className="text-xs text-slate-400 dark:text-slate-500">Nguồn: {record.source} · {record.phone}</div>
          </div>
        </div>
      ),
    },
    {
      title: 'NHU CẦU',
      dataIndex: 'demand',
      key: 'demand',
      render: (text) => <span className="font-medium text-slate-700 dark:text-slate-300">{text}</span>
    },
    {
      title: 'TRẠNG THÁI',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color = 'default';
        if (status.includes('gọi lại') || status.includes('nại giá')) color = 'error';
        else if (status.includes('báo giá')) color = 'warning';
        else if (status.includes('cọc')) color = 'processing';
        else if (status.includes('Tư vấn') || status.includes('hợp đồng')) color = 'success';
        return <Tag color={color}>{status}</Tag>;
      }
    },
    {
      title: 'GIÁ TRỊ DỰ KIẾN',
      dataIndex: 'value',
      key: 'value',
      render: (val) => <span className="font-semibold text-slate-900 dark:text-slate-100">{val} tr</span>
    },
    {
      title: 'HẠN XỬ LÝ',
      dataIndex: 'deadline',
      key: 'deadline',
      render: (dl) => {
        let color = dl.includes('Quá hạn') ? 'red' : dl.includes('Hôm nay') ? 'orange' : 'default';
        return <Tag color={color}>{dl}</Tag>;
      }
    },
    {
      title: '',
      key: 'action',
      render: () => <Button size="small" className="rounded-lg hover:text-blue-600 border-slate-200 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200">Mở</Button>
    }
  ];

  const customerData = [
    { key: '1', avatar: 'TV', name: 'Trần Thu Vân', source: 'Facebook', phone: '0938***412', demand: 'K-Lift Signature', status: 'Hẹn gọi lại', value: '68', deadline: 'Quá hạn 18 giờ' },
    { key: '2', avatar: 'QB', name: 'Lê Quốc Bảo', source: 'Google', phone: '0907***188', demand: 'Newhair 2.500 nang', status: 'Chờ báo giá', value: '195', deadline: 'Quá hạn 1 ngày' },
    { key: '3', avatar: 'HN', name: 'Phạm Hồng Nhung', source: 'Zalo OA', phone: '0912***730', demand: 'K-Reshape mũi', status: 'Chờ cọc', value: '92', deadline: 'Hôm nay 12:00' },
    { key: '4', avatar: 'MA', name: 'Đỗ Mai Anh', source: 'TikTok', phone: '0977***205', demand: 'K-Brightening', status: 'Tư vấn online', value: '36', deadline: 'Hôm nay 10:30' },
    { key: '5', avatar: 'KT', name: 'Nguyễn Kiều Trang', source: 'KH cũ', phone: '0903***641', demand: 'K-Prime + PTTM', status: 'Chốt hợp đồng', value: '145', deadline: 'Hôm nay 15:00' },
    { key: '6', avatar: 'LC', name: 'Vũ Lan Chi', source: 'Hotline', phone: '0935***022', demand: 'K-Renewal', status: 'Khiếu nại giá', value: '24', deadline: 'Ưu tiên' },
  ];

  return (
    <div className="p-4 sm:p-6 bg-slate-100/60 dark:bg-slate-950 min-h-screen font-sans text-slate-800 dark:text-slate-100 transition-colors">
      
      {/* 1. Thanh tiêu đề & Chọn vị trí */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6 bg-white dark:bg-slate-900 p-4 rounded-xl shadow-sm border border-slate-200/60 dark:border-slate-800">
        <div>
          <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100">Bảng điều hành theo vị trí</h2>
          <p className="text-xs text-slate-500 dark:text-slate-400">Màn đầu ca. Một khung duy nhất cho 13 vị trí – chỉ dữ liệu và quyền hiển thị đổi theo vai trò.</p>
        </div>
        <div className="flex items-center space-x-3 w-full md:w-auto justify-between md:justify-start">
          <span className="text-sm font-medium text-slate-600 dark:text-slate-300">Vị trí</span>
          <Select 
            value={selectedRole} 
            onChange={setSelectedRole} 
            className="w-48 sm:w-56"
          >
            <Option value="telesale">Telesale / Tư vấn Online</Option>
            <Option value="cskh">CSKH & Tổng đài</Option>
            <Option value="quanly">Quản lý cơ sở</Option>
          </Select>
        </div>
      </div>

      {/* 2. Khối Phễu trong ngày */}
      <Card bordered={false} className="shadow-sm rounded-xl mb-6 border border-slate-200/60 dark:border-slate-800 dark:bg-slate-900">
        <div className="text-xs text-slate-500 dark:text-slate-400 mb-4 flex items-center justify-between">
          <span><strong className="text-slate-700 dark:text-slate-300">Phễu trong ngày</strong> Cắt ngang lúc 14:20 · bấm một cột để mở màn tương ứng</span>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-center">
          <div className="bg-white dark:bg-slate-800/80 p-4 rounded-xl border border-slate-200 dark:border-slate-700 relative shadow-sm pb-6">
            <div className="text-2xl font-bold text-slate-800 dark:text-slate-100">10</div>
            <div className="text-sm font-bold text-slate-700 dark:text-slate-300 mt-1">Lịch hẹn hôm nay</div>
            <div className="text-xs text-slate-400 dark:text-slate-400 mt-1">Đã xác nhận trước</div>
            <div className="absolute bottom-0 left-4 right-4 h-[3px] bg-blue-600 rounded-t-full"></div>
          </div>

          <div className="bg-white dark:bg-slate-800/80 p-4 rounded-xl border border-slate-200 dark:border-slate-700 relative shadow-sm pb-6">
            <div className="flex items-baseline justify-between">
              <div className="text-2xl font-bold text-slate-800 dark:text-slate-100">3</div>
              <span className="text-xs text-red-500 font-bold bg-red-50 dark:bg-red-950/60 px-1.5 py-0.5 rounded">rớt 70%</span>
            </div>
            <div className="text-sm font-bold text-slate-700 dark:text-slate-300 mt-1">Khách có mặt</div>
            <div className="text-xs text-slate-400 dark:text-slate-400 mt-1">Đã check-in tại cơ sở</div>
            <div className="absolute bottom-0 left-4 right-4 h-[3px] bg-teal-500 rounded-t-full"></div>
          </div>

          <div className="bg-white dark:bg-slate-800/80 p-4 rounded-xl border border-slate-200 dark:border-slate-700 relative shadow-sm pb-6">
            <div className="flex items-baseline justify-between">
              <div className="text-2xl font-bold text-slate-800 dark:text-slate-100">2</div>
              <span className="text-xs text-red-500 font-bold bg-red-50 dark:bg-red-950/60 px-1.5 py-0.5 rounded">rớt 33%</span>
            </div>
            <div className="text-sm font-bold text-slate-700 dark:text-slate-300 mt-1">Vào tư vấn</div>
            <div className="text-xs text-slate-400 dark:text-slate-400 mt-1">Đang hoặc đã tư vấn</div>
            <div className="absolute bottom-0 left-4 right-4 h-[3px] bg-purple-500 rounded-t-full"></div>
          </div>

          <div className="bg-white dark:bg-slate-800/80 p-4 rounded-xl border border-slate-200 dark:border-slate-700 relative shadow-sm pb-6">
            <div className="flex items-baseline justify-between">
              <div className="text-2xl font-bold text-slate-800 dark:text-slate-100">1</div>
              <span className="text-xs text-red-500 font-bold bg-red-50 dark:bg-red-950/60 px-1.5 py-0.5 rounded">rớt 50%</span>
            </div>
            <div className="text-sm font-bold text-slate-700 dark:text-slate-300 mt-1">Tư vấn xong</div>
            <div className="text-xs text-slate-400 dark:text-slate-400 mt-1">Chốt hoặc rớt, có lý do</div>
            <div className="absolute bottom-0 left-4 right-4 h-[3px] bg-green-500 rounded-t-full"></div>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-slate-100 dark:border-slate-800">
          <div className="text-xs text-slate-500 dark:text-slate-400 mb-3 font-medium">TỒN ĐỌNG CHUYỂN TIẾP – KHÔNG CÙNG NHÓM KHÁCH CỦA PHỄU TRÊN</div>
          
          <div className="overflow-x-auto pb-2">
            <div className="flex space-x-4 w-max">
              <div className="bg-slate-50/80 dark:bg-slate-800/50 p-3.5 rounded-xl border border-slate-200/60 dark:border-slate-700 w-[300px] flex-shrink-0">
                <div className="text-lg font-bold text-slate-800 dark:text-slate-100">6</div>
                <div className="text-xs font-bold text-slate-700 dark:text-slate-300">Chờ xếp ca</div>
                <div className="text-[11px] text-slate-400 dark:text-slate-400 mt-0.5">Hồ sơ đã chốt các ngày trước, chờ điều phối</div>
              </div>
              <div className="bg-slate-50/80 dark:bg-slate-800/50 p-3.5 rounded-xl border border-slate-200/60 dark:border-slate-700 w-[300px] flex-shrink-0">
                <div className="text-lg font-bold text-slate-800 dark:text-slate-100">12</div>
                <div className="text-xs font-bold text-slate-700 dark:text-slate-300">Ca trên lịch thực hiện</div>
                <div className="text-[11px] text-slate-400 dark:text-slate-400 mt-0.5">Đã có đầy đủ phòng, ekip, khung giờ</div>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* 3. Chào buổi chiều & Khung Nhịp ngày Timeline chuẩn */}
      <Card bordered={false} className="shadow-sm rounded-xl mb-6 border border-slate-200/60 dark:border-slate-800 dark:bg-slate-900">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-4">
          <div>
            <h3 className="text-base font-bold text-slate-800 dark:text-slate-100">Chào buổi chiều, <span className="text-amber-700 dark:text-amber-400">Ms. Giang</span></h3>
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">Còn 578 triệu để chạm target tháng, 11 ngày làm việc. 6 khách quá hạn gọi lại từ hôm qua cần xử lý trước 10:00.</p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Tag className="bg-red-50 text-red-700 border-red-200 dark:bg-red-950/50 dark:text-red-300 dark:border-red-900 font-medium px-3 py-1">4 QUÁ HẠN</Tag>
            <Tag className="bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/50 dark:text-amber-300 dark:border-amber-900 font-medium px-3 py-1">5 HÔM NAY</Tag>
            <Tag className="bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/50 dark:text-rose-300 dark:border-rose-900 font-medium px-3 py-1">3 CẦN XỬ LÝ</Tag>
            <Tag className="bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700 font-medium px-3 py-1">6 ĐANG THEO DÕI</Tag>
          </div>
        </div>

        {/* Khung Nhịp ngày Timeline */}
        <div className="bg-slate-50/50 dark:bg-slate-800/40 p-4 rounded-xl border border-slate-200/60 dark:border-slate-700 mt-4">
          <div className="text-xs text-slate-500 dark:text-slate-400 mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
            <span>Nhịp ngày <strong className="text-slate-700 dark:text-slate-300">Ca 08:00 – 17:30 · Tư vấn Online</strong></span>
            <div className="flex flex-wrap gap-3 text-[11px] text-slate-500 dark:text-slate-400 font-medium">
              <span className="flex items-center"><span className="w-2 h-2 rounded-full bg-red-600 mr-1"></span> Gấp</span>
              <span className="flex items-center"><span className="w-2 h-2 rounded-full bg-amber-500 mr-1"></span> Ưu tiên</span>
              <span className="flex items-center"><span className="w-2 h-2 rounded-full bg-teal-600 mr-1"></span> Theo lịch</span>
              <span className="flex items-center"><span className="w-2 h-2 rounded-full bg-slate-400 mr-1"></span> Linh hoạt</span>
            </div>
          </div>
          
          <div className="relative pt-6 pb-4 overflow-x-auto">
            <div className="min-w-[800px]">
              <div className="grid grid-cols-10 text-xs text-slate-400 border-b border-slate-200 dark:border-slate-700 pb-2 mb-6">
                <span>07:00</span>
                <span>08:00</span>
                <span>09:00</span>
                <span>10:00</span>
                <span>11:00</span>
                <span>12:00</span>
                <span>13:00</span>
                <span>14:00</span>
                <span>15:00</span>
                <span className="text-right">17:00</span>
              </div>

              <div className="relative h-12 bg-slate-200/50 dark:bg-slate-700/50 rounded-xl flex items-center px-1">
                <div className="absolute top-[-20px] bottom-[0px] left-[80%] z-20 flex flex-col items-center pointer-events-none">
                  <div className="bg-slate-800 dark:bg-slate-100 dark:text-slate-900 text-white text-[9px] font-bold px-1.5 py-0.5 rounded shadow-sm mb-1">15:00</div>
                  <div className="w-3 h-3 bg-slate-800 dark:bg-slate-100 rounded-full shadow-md border-2 border-white dark:border-slate-900"></div>
                  <div className="w-[2px] bg-slate-800 dark:bg-slate-100 h-full shadow-sm"></div>
                </div>

                <div 
                  className="absolute h-9 bg-amber-100 dark:bg-amber-950/80 border border-amber-300 dark:border-amber-700 text-amber-900 dark:text-amber-200 rounded-lg px-2.5 flex flex-col justify-center shadow-sm cursor-pointer hover:bg-amber-200 dark:hover:bg-amber-900 transition-all truncate"
                  style={{ left: '10%', width: '20%' }}
                  title="Gọi 18 lead mới (08:00 - 10:00)"
                >
                  <div className="text-xs font-bold truncate">📞 Gọi 18 lead mới</div>
                  <div className="text-[10px] text-amber-700 dark:text-amber-400">08:00 - 10:00</div>
                </div>

                <div 
                  className="absolute h-9 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 rounded-lg px-2 flex flex-col justify-center shadow-sm cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-700 transition-all truncate"
                  style={{ left: '35%', width: '12%' }}
                  title="Tư vấn nhanh (10:30 - 11:30)"
                >
                  <div className="text-xs font-semibold truncate">💬 Tư vấn nhanh</div>
                  <div className="text-[10px] text-slate-400">10:30 - 11:30</div>
                </div>

                <div 
                  className="absolute h-9 bg-teal-50 dark:bg-teal-950/60 border border-teal-200 dark:border-teal-800 text-teal-900 dark:text-teal-200 rounded-lg px-2 flex flex-col justify-center shadow-sm cursor-pointer hover:bg-teal-100 dark:hover:bg-teal-900 transition-all truncate"
                  style={{ left: '48%', width: '15%' }}
                  title="Nhắc lịch 5 khách (11:45 - 13:15)"
                >
                  <div className="text-xs font-semibold truncate">📅 Nhắc lịch khách</div>
                  <div className="text-[10px] text-teal-600 dark:text-teal-400">11:45 - 13:15</div>
                </div>

                <div 
                  className="absolute h-9 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 rounded-lg px-2 flex flex-col justify-center shadow-sm cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-700 transition-all truncate"
                  style={{ left: '65%', width: '14%' }}
                  title="Chăm lead cũ (13:30 - 15:00)"
                >
                  <div className="text-xs font-semibold truncate">☕ Chăm lead cũ</div>
                  <div className="text-[10px] text-slate-400">13:30 - 15:00</div>
                </div>

                <div 
                  className="absolute h-9 bg-amber-100 dark:bg-amber-950/80 border border-amber-300 dark:border-amber-700 text-amber-900 dark:text-amber-200 rounded-lg px-2.5 flex flex-col justify-center shadow-sm cursor-pointer hover:bg-amber-200 dark:hover:bg-amber-900 transition-all truncate"
                  style={{ left: '81%', width: '18%' }}
                  title="Chốt hợp đồng (15:15 - 17:00)"
                >
                  <div className="text-xs font-bold truncate">🤝 Chốt hợp đồng</div>
                  <div className="text-[10px] text-amber-700 dark:text-amber-400">15:15 - 17:00</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* 4. Thống kê chỉ số kinh doanh */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Card bordered={false} className="shadow-sm rounded-xl border border-slate-200/60 dark:border-slate-800 dark:bg-slate-900">
          <div className="text-xs text-slate-400 uppercase font-bold tracking-wider">Doanh thu tháng</div>
          <div className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-1">1,42 <span className="text-sm font-normal text-slate-500">tỷ</span></div>
          <div className="flex justify-between text-xs text-slate-400 mt-3">
            <span>Target 2,0 tỷ</span>
            <span>Còn 578 tr</span>
          </div>
          <div className="w-full bg-slate-100 dark:bg-slate-800 h-1.5 rounded-full mt-1.5 overflow-hidden">
            <div className="bg-amber-700 h-full w-[71%]" />
          </div>
        </Card>
        <Card bordered={false} className="shadow-sm rounded-xl border border-slate-200/60 dark:border-slate-800 dark:bg-slate-900">
          <div className="text-xs text-slate-400 uppercase font-bold tracking-wider">Closing Rate</div>
          <div className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-1">18,4%</div>
          <div className="flex justify-between text-xs text-slate-400 mt-3">
            <span>Target 25%</span>
            <span className="text-red-500 font-medium">-6,6 điểm</span>
          </div>
          <div className="w-full bg-slate-100 dark:bg-slate-800 h-1.5 rounded-full mt-1.5 overflow-hidden">
            <div className="bg-amber-700 h-full w-[65%]" />
          </div>
        </Card>
        <Card bordered={false} className="shadow-sm rounded-xl border border-slate-200/60 dark:border-slate-800 dark:bg-slate-900">
          <div className="text-xs text-slate-400 uppercase font-bold tracking-wider">Lead đã nhận</div>
          <div className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-1">146 <span className="text-sm font-normal text-slate-500">SĐT</span></div>
          <div className="flex justify-between text-xs text-slate-400 mt-3">
            <span>Đã liên hệ 128</span>
            <span>Tồn 18</span>
          </div>
          <div className="w-full bg-slate-100 dark:bg-slate-800 h-1.5 rounded-full mt-1.5 overflow-hidden">
            <div className="bg-teal-700 h-full w-[88%]" />
          </div>
        </Card>
        <Card bordered={false} className="shadow-sm rounded-xl border border-slate-200/60 dark:border-slate-800 dark:bg-slate-900">
          <div className="text-xs text-slate-400 uppercase font-bold tracking-wider">Lịch hẹn đã chốt</div>
          <div className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-1">31 <span className="text-sm font-normal text-slate-500">lịch</span></div>
          <div className="flex justify-between text-xs text-slate-400 mt-3">
            <span>Đến hẹn 19</span>
            <span>Tỷ lệ đến 61%</span>
          </div>
          <div className="w-full bg-slate-100 dark:bg-slate-800 h-1.5 rounded-full mt-1.5 overflow-hidden">
            <div className="bg-teal-700 h-full w-[61%]" />
          </div>
        </Card>
      </div>

      {/* 5. Khối Phễu chuyển đổi của tôi & Nghiệp vụ / Thông báo */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-6">
        
        {/* Cột trái: Phễu chuyển đổi của tôi */}
        <Card bordered={false} className="lg:col-span-7 shadow-sm rounded-xl border border-slate-200/60 dark:border-slate-800 dark:bg-slate-900">
          <div className="flex justify-between items-center mb-6">
            <h3 className="font-bold text-slate-800 dark:text-slate-100 text-base">Phễu chuyển đổi của tôi</h3>
            <span className="text-xs text-slate-400 font-medium">Luỹ kế tháng 8</span>
          </div>

          <div className="space-y-5">
            <div>
              <div className="flex justify-between text-xs font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                <span>Lead được chia</span>
                <span>146 <span className="text-slate-400 font-normal">100% đầu phễu</span></span>
              </div>
              <div className="w-full bg-slate-100 dark:bg-slate-800 h-7 rounded-lg overflow-hidden relative flex items-center">
                <div className="bg-teal-700 h-full rounded-lg" style={{ width: '100%' }} />
              </div>
              <div className="text-[11px] text-red-500 mt-1">rớt 18 khách · 12.3%</div>
            </div>

            <div>
              <div className="flex justify-between text-xs font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                <span>Đã liên hệ</span>
                <span>128 <span className="text-slate-400 font-normal">87.7% đầu phễu</span></span>
              </div>
              <div className="w-full bg-slate-100 dark:bg-slate-800 h-7 rounded-lg overflow-hidden relative flex items-center">
                <div className="bg-teal-700 h-full rounded-lg" style={{ width: '87.7%' }} />
              </div>
              <div className="text-[11px] text-red-500 mt-1">rớt 63 khách · 49.2%</div>
            </div>

            <div>
              <div className="flex justify-between text-xs font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                <span>Đã báo giá</span>
                <span>65 <span className="text-slate-400 font-normal">44.5% đầu phễu</span></span>
              </div>
              <div className="w-full bg-slate-100 dark:bg-slate-800 h-7 rounded-lg overflow-hidden relative flex items-center">
                <div className="bg-teal-700 h-full rounded-lg" style={{ width: '44.5%' }} />
              </div>
              <div className="text-[11px] text-red-500 mt-1">rớt 34 khách · 52.3%</div>
            </div>

            <div>
              <div className="flex justify-between text-xs font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                <span>Hẹn tư vấn</span>
                <span>31 <span className="text-slate-400 font-normal">21.2% đầu phễu</span></span>
              </div>
              <div className="w-full bg-slate-100 dark:bg-slate-800 h-7 rounded-lg overflow-hidden relative flex items-center">
                <div className="bg-teal-700 h-full rounded-lg" style={{ width: '21.2%' }} />
              </div>
              <div className="text-[11px] text-red-500 mt-1">rớt 19 khách · 61.3%</div>
            </div>

            <div>
              <div className="flex justify-between text-xs font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                <span>Chốt</span>
                <span>12 <span className="text-slate-400 font-normal">8.2% đầu phễu</span></span>
              </div>
              <div className="w-full bg-slate-100 dark:bg-slate-800 h-7 rounded-lg overflow-hidden relative flex items-center">
                <div className="bg-teal-700 h-full rounded-lg" style={{ width: '8.2%' }} />
              </div>
            </div>
          </div>
        </Card>

        {/* Cột phải: Nghiệp vụ của tôi & Thông báo */}
        <div className="lg:col-span-5 space-y-6">
          
          {/* Nghiệp vụ của tôi */}
          <Card bordered={false} className="shadow-sm rounded-xl border border-slate-200/60 dark:border-slate-800 dark:bg-slate-900" bodyStyle={{ padding: '16px' }}>
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-bold text-slate-800 dark:text-slate-100 text-sm">Nghiệp vụ của tôi</h3>
              <span className="text-xs text-slate-400 cursor-pointer hover:underline">Truy cập nhanh</span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className="p-3 bg-slate-50 dark:bg-slate-800/60 rounded-xl border border-slate-200/60 dark:border-slate-700 flex items-center justify-between cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition">
                <div className="flex items-center space-x-2.5">
                  <span className="w-7 h-7 rounded-lg bg-slate-200 dark:bg-slate-700 flex items-center text-xs justify-center font-bold text-slate-700 dark:text-slate-200">TV</span>
                  <div>
                    <div className="text-xs font-bold text-slate-800 dark:text-slate-100">Lịch tư vấn</div>
                    <div className="text-[10px] text-slate-400">Hàng chờ tư vấn</div>
                  </div>
                </div>
                <Tag color="error" className="m-0 text-[10px]">6</Tag>
              </div>

              <div className="p-3 bg-slate-50 dark:bg-slate-800/60 rounded-xl border border-slate-200/60 dark:border-slate-700 flex items-center justify-between cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition">
                <div className="flex items-center space-x-2.5">
                  <span className="w-7 h-7 rounded-lg bg-slate-200 dark:bg-slate-700 flex items-center text-xs justify-center font-bold text-slate-700 dark:text-slate-200">KH</span>
                  <div>
                    <div className="text-xs font-bold text-slate-800 dark:text-slate-100">Khách hàng</div>
                    <div className="text-[10px] text-slate-400">Hồ sơ & lịch sử</div>
                  </div>
                </div>
              </div>

              <div className="p-3 bg-slate-50 dark:bg-slate-800/60 rounded-xl border border-slate-200/60 dark:border-slate-700 flex items-center justify-between cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition">
                <div className="flex items-center space-x-2.5">
                  <span className="w-7 h-7 rounded-lg bg-slate-200 dark:bg-slate-700 flex items-center text-xs justify-center font-bold text-slate-700 dark:text-slate-200">LH</span>
                  <div>
                    <div className="text-xs font-bold text-slate-800 dark:text-slate-100">Lịch hẹn</div>
                    <div className="text-[10px] text-slate-400">Đặt & xác nhận</div>
                  </div>
                </div>
                <Tag color="processing" className="m-0 text-[10px]">3</Tag>
              </div>

              <div className="p-3 bg-slate-50 dark:bg-slate-800/60 rounded-xl border border-slate-200/60 dark:border-slate-700 flex items-center justify-between cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition">
                <div className="flex items-center space-x-2.5">
                  <span className="w-7 h-7 rounded-lg bg-slate-200 dark:bg-slate-700 flex items-center text-xs justify-center font-bold text-slate-700 dark:text-slate-200">ĐH</span>
                  <div>
                    <div className="text-xs font-bold text-slate-800 dark:text-slate-100">Bán hàng & Đơn hàng</div>
                    <div className="text-[10px] text-slate-400">Chốt đơn, cọc</div>
                  </div>
                </div>
                <Tag color="processing" className="m-0 text-[10px]">2</Tag>
              </div>

              <div className="p-3 bg-slate-50 dark:bg-slate-800/60 rounded-xl border border-slate-200/60 dark:border-slate-700 flex items-center justify-between cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition">
                <div className="flex items-center space-x-2.5">
                  <span className="w-7 h-7 rounded-lg bg-slate-200 dark:bg-slate-700 flex items-center text-xs justify-center font-bold text-slate-700 dark:text-slate-200">CC</span>
                  <div>
                    <div className="text-xs font-bold text-slate-800 dark:text-slate-100">Call center</div>
                    <div className="text-[10px] text-slate-400">Tổng đài CSKH</div>
                  </div>
                </div>
              </div>

              <div className="p-3 bg-slate-50 dark:bg-slate-800/60 rounded-xl border border-slate-200/60 dark:border-slate-700 flex items-center justify-between cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition">
                <div className="flex items-center space-x-2.5">
                  <span className="w-7 h-7 rounded-lg bg-slate-200 dark:bg-slate-700 flex items-center text-xs justify-center font-bold text-slate-700 dark:text-slate-200">BC</span>
                  <div>
                    <div className="text-xs font-bold text-slate-800 dark:text-slate-100">Báo cáo</div>
                    <div className="text-[10px] text-slate-400">Dashboard số liệu</div>
                  </div>
                </div>
              </div>

              <div className="p-3 bg-slate-50 dark:bg-slate-800/60 rounded-xl border border-slate-200/60 dark:border-slate-700 flex items-center justify-between cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition">
                <div className="flex items-center space-x-2.5">
                  <span className="w-7 h-7 rounded-lg bg-slate-200 dark:bg-slate-700 flex items-center text-xs justify-center font-bold text-slate-700 dark:text-slate-200">TL</span>
                  <div>
                    <div className="text-xs font-bold text-slate-800 dark:text-slate-100">Tài liệu</div>
                    <div className="text-[10px] text-slate-400">Quy trình, biểu mẫu</div>
                  </div>
                </div>
              </div>

              <div className="p-3 bg-slate-50 dark:bg-slate-800/60 rounded-xl border border-slate-200/60 dark:border-slate-700 flex items-center justify-between cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition">
                <div className="flex items-center space-x-2.5">
                  <span className="w-7 h-7 rounded-lg bg-slate-200 dark:bg-slate-700 flex items-center text-xs justify-center font-bold text-slate-700 dark:text-slate-200">CH</span>
                  <div>
                    <div className="text-xs font-bold text-slate-800 dark:text-slate-100">Khothi Chat</div>
                    <div className="text-[10px] text-slate-400">Chat nhóm</div>
                  </div>
                </div>
                <Tag color="error" className="m-0 text-[10px]">4</Tag>
              </div>
            </div>
          </Card>

          {/* Thông báo & Truyền thông */}
          <Card bordered={false} className="shadow-sm rounded-xl border border-slate-200/60 dark:border-slate-800 dark:bg-slate-900" bodyStyle={{ padding: '16px' }}>
            <div className="flex justify-between items-center mb-3">
              <h3 className="font-bold text-slate-800 dark:text-slate-100 text-sm">Thông báo & Truyền thông</h3>
              <span className="text-xs text-slate-400">5 tin</span>
            </div>

            <div className="space-y-3">
              <div className="p-3 bg-amber-50/60 dark:bg-amber-950/40 rounded-xl border border-amber-200/60 dark:border-amber-900/60">
                <div className="flex items-center space-x-2 mb-1">
                  <Tag color="warning" className="m-0 text-[10px]">Thông báo</Tag>
                  <Tag className="m-0 text-[10px] bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700">Ghim</Tag>
                </div>
                <div className="text-xs font-bold text-slate-800 dark:text-slate-100 mb-1">Điều chỉnh chính sách cọc dịch vụ từ 01/09/2026</div>
                <div className="text-[11px] text-slate-500 dark:text-slate-400 mb-2">Mức cọc tối thiểu cho phác đồ Signature tăng lên 20% giá trị. Toàn bộ báo giá phát hành từ 01/09 áp dụng biểu mẫu mới.</div>
                <div className="flex justify-between text-[10px] text-slate-400">
                  <span>Khối Kinh doanh · 28/08</span>
                  <span className="text-amber-700 dark:text-amber-400 font-semibold">Bắt buộc đọc</span>
                </div>
              </div>

              <div className="p-3 bg-slate-50 dark:bg-slate-800/60 rounded-xl border border-slate-200/60 dark:border-slate-700">
                <div className="flex items-center space-x-2 mb-1">
                  <Tag color="cyan" className="m-0 text-[10px]">Truyền thông</Tag>
                </div>
                <div className="text-xs font-bold text-slate-800 dark:text-slate-100 mb-1">Bộ nhận diện K-Protocol System bản 2.0 đã lên kho tài liệu</div>
                <div className="text-[11px] text-slate-500 dark:text-slate-400 mb-2">8 phác đồ có ấn phẩm tư vấn mới, thay toàn bộ bản in cũ tại quầy. Bản digital dùng cho tư vấn online.</div>
                <div className="text-[10px] text-slate-400">Marketing · 27/08</div>
              </div>
            </div>
          </Card>

        </div>
      </div>

      {/* 6. Công việc của tôi */}
      <Card bordered={false} className="shadow-sm rounded-xl mb-6 border border-slate-200/60 dark:border-slate-800 dark:bg-slate-900" bodyStyle={{ padding: 0 }}>
        <div className="flex justify-between items-center p-4 border-b border-slate-100 dark:border-slate-800">
          <h3 className="font-bold text-slate-800 dark:text-slate-100 text-base">Công việc của tôi</h3>
          <span className="text-xs text-slate-400 font-medium">
            {tasks.length} đầu việc ({tasks.filter(t => t.completed).length} đã xong)
          </span>
        </div>

        {/* 5 tiêu chí / tab */}
        <div className="grid grid-cols-2 sm:grid-cols-5 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
          <div 
            onClick={() => setActiveTaskTab('overdue')}
            className={`p-4 text-center cursor-pointer border-r border-slate-200 dark:border-slate-800 transition-all relative ${activeTaskTab === 'overdue' ? 'bg-slate-50/50 dark:bg-slate-800/50' : 'hover:bg-slate-50 dark:hover:bg-slate-800/30'}`}
          >
            <div className="text-xl font-bold text-slate-800 dark:text-slate-100">{tasks.filter(t => t.tab === 'overdue').length}</div>
            <div className="text-xs text-slate-600 dark:text-slate-300 font-medium mt-1">Quá hạn</div>
            {activeTaskTab === 'overdue' && <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-red-700" />}
          </div>

          <div 
            onClick={() => setActiveTaskTab('today')}
            className={`p-4 text-center cursor-pointer border-r border-slate-200 dark:border-slate-800 transition-all relative ${activeTaskTab === 'today' ? 'bg-slate-50/50 dark:bg-slate-800/50' : 'hover:bg-slate-50 dark:hover:bg-slate-800/30'}`}
          >
            <div className="text-xl font-bold text-slate-800 dark:text-slate-100">{tasks.filter(t => t.tab === 'today').length}</div>
            <div className="text-xs text-slate-600 dark:text-slate-300 font-medium mt-1">Hôm nay</div>
            {activeTaskTab === 'today' && <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-amber-700" />}
          </div>

          <div 
            onClick={() => setActiveTaskTab('handle')}
            className={`p-4 text-center cursor-pointer border-r border-slate-200 dark:border-slate-800 transition-all relative ${activeTaskTab === 'handle' ? 'bg-slate-50/50 dark:bg-slate-800/50' : 'hover:bg-slate-50 dark:hover:bg-slate-800/30'}`}
          >
            <div className="text-xl font-bold text-slate-800 dark:text-slate-100">{tasks.filter(t => t.tab === 'handle').length}</div>
            <div className="text-xs text-slate-600 dark:text-slate-300 font-medium mt-1">Cần xử lý</div>
            {activeTaskTab === 'handle' && <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-red-700" />}
          </div>

          <div 
            onClick={() => setActiveTaskTab('remain')}
            className={`p-4 text-center cursor-pointer border-r border-slate-200 dark:border-slate-800 transition-all relative ${activeTaskTab === 'remain' ? 'bg-slate-50/50 dark:bg-slate-800/50' : 'hover:bg-slate-50 dark:hover:bg-slate-800/30'}`}
          >
            <div className="text-xl font-bold text-slate-800 dark:text-slate-100">{tasks.filter(t => t.tab === 'remain').length}</div>
            <div className="text-xs text-slate-600 dark:text-slate-300 font-medium mt-1">Việc tồn</div>
            {activeTaskTab === 'remain' && <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-slate-600" />}
          </div>

          <div 
            onClick={() => setActiveTaskTab('upcoming')}
            className={`p-4 text-center cursor-pointer transition-all relative col-span-2 sm:col-span-1 ${activeTaskTab === 'upcoming' ? 'bg-slate-50/50 dark:bg-slate-800/50' : 'hover:bg-slate-50 dark:hover:bg-slate-800/30'}`}
          >
            <div className="text-xl font-bold text-slate-800 dark:text-slate-100">{tasks.filter(t => t.tab === 'upcoming').length}</div>
            <div className="text-xs text-slate-600 dark:text-slate-300 font-medium mt-1">Sắp tới</div>
            {activeTaskTab === 'upcoming' && <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-teal-700" />}
          </div>
        </div>

        {/* Danh sách đầu việc tương ứng hiển thị theo tab */}
        <div className="p-4 bg-white dark:bg-slate-900 space-y-3">
          {filteredTasks.length > 0 ? (
            filteredTasks.map(task => (
              <div 
                key={task.id}
                className={`p-3 rounded-xl border border-slate-200/60 dark:border-slate-700 flex items-center justify-between transition-all ${
                  task.completed 
                    ? 'bg-slate-100 dark:bg-slate-800/30 opacity-60' 
                    : 'bg-slate-50/80 dark:bg-slate-800/60 border-l-4 border-l-blue-600'
                }`}
              >
                <div className="flex items-center space-x-3">
                  <input 
                    type="checkbox" 
                    checked={task.completed}
                    onChange={() => handleToggleTask(task.id)}
                    className="rounded border-slate-300 dark:border-slate-600 w-4 h-4 text-blue-600 cursor-pointer" 
                  />
                  <div>
                    <div className={`text-xs font-bold ${task.completed ? 'line-through text-slate-400 dark:text-slate-500' : 'text-slate-800 dark:text-slate-100'}`}>
                      {task.title}
                    </div>
                    <div className="text-[11px] text-slate-400">{task.desc}</div>
                  </div>
                </div>
                
                <div className="flex items-center space-x-2">
                  {task.completed ? (
                    <Tag color="success" className="m-0 text-[11px]">Đã hoàn thành</Tag>
                  ) : (
                    <Tag color={task.tagColor} className="m-0 text-[11px]">{task.tagText}</Tag>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-6 text-xs text-slate-400">Không có đầu việc nào trong mục này</div>
          )}
        </div>
      </Card>

      {/* 7. Bảng Khách hàng cần liên hệ */}
      <Card 
        title={<span className="font-bold text-slate-800 dark:text-slate-100">Khách hàng cần liên hệ</span>} 
        bordered={false} 
        className="shadow-sm rounded-xl border border-slate-200/60 dark:border-slate-800 dark:bg-slate-900"
        extra={<span className="text-xs text-blue-600 dark:text-blue-400 cursor-pointer font-medium hover:underline">Sắp xếp theo hạn xử lý</span>}
      >
        <div className="overflow-x-auto">
          <Table dataSource={customerData} columns={customerColumns} pagination={false} />
        </div>
      </Card>

    </div>
  );
}